import $ from 'jquery';
export const restartTabs = () => {
    $('#nav-profile-tab-Contenido-D').removeClass('active');
    $('#nav-profile-tab-Finanzas').removeClass('active');
    $('#nav-profile-tab-logistica').removeClass('active');
    $('#nav-profile-tab-Costs-D').removeClass('active');
    $('#nav-profile-tab-Complemento').removeClass('active');
    $('#nav-profile-tab-Attach').removeClass('active');

    $('#dataContenidoDocument').removeClass('active');
    $('#dataFinanzas').removeClass('active');
    $('#dataLogistica').removeClass('active');
    $('#dataCostsDocument').removeClass('active');
    $('#dataComplemento').removeClass('active');
    $('#dataAttach').removeClass('active');
    $('#invFields').removeClass('active');

    $('#dataContenidoDocument').removeClass('show');
    $('#dataFinanzas').removeClass('show');
    $('#dataLogistica').removeClass('show');
    $('#dataCostsDocument').removeClass('show');
    $('#dataComplemento').removeClass('show');
    $('#dataAttach').removeClass('show');
    $('#invFields').removeClass('show');

    $('#nav-profile-tab-Contenido-D').addClass('active');
    $('#dataContenidoDocument').addClass('active')
    $('#dataContenidoDocument').addClass('show')
};